import { panelChangeListener } from 'features/toolbar/listeners/panelChangeListener';
import { AppStartListening } from 'store/listenerMiddleware';

export const addToolbarListeners = (startListening: AppStartListening) => {
  panelChangeListener(startListening);
};
